export default __webpack_public_path__ + "static/media/hht2_ep18_book_wp_01.eb363f33.jpg";